(function () {
  function readVar(el, name, fallback) {
    if (!el) return fallback;
    var value = getComputedStyle(el).getPropertyValue(name).trim();
    return value || fallback;
  }

  function getReferenceColors() {
    var swatch = document.querySelector('.rd-variant-card__media');
    var fallbackScope = document.querySelector('.rd-product') || document.querySelector('main') || document.body;

    return {
      border: readVar(swatch, '--rd-variant-border', readVar(fallbackScope, '--rd-variant-border', '#D0D0D0')),
      activeBorder: readVar(swatch, '--rd-variant-active-border', readVar(fallbackScope, '--rd-variant-active-border', '#D0D0D0')),
      bg: readVar(swatch, '--rd-variant-bg', readVar(fallbackScope, '--rd-variant-bg', 'transparent')),
      activeBg: readVar(swatch, '--rd-variant-active-bg', readVar(fallbackScope, '--rd-variant-active-bg', '#E5E5E5')),
      text: readVar(fallbackScope, '--rd-product-text', '#1A1A1A'),
      activeText: readVar(swatch, '--rd-variant-active-text', readVar(fallbackScope, '--rd-variant-active-text', '#1A1A1A'))
    };
  }

  function applyState(el, colors) {
    var isActive = el.classList.contains('is-active');
    var isDisabled = el.classList.contains('is-disabled');

    el.style.setProperty('transition', 'none', 'important');
    el.style.setProperty('background-color', isActive ? colors.activeBg : colors.bg, 'important');
    el.style.setProperty('border-color', isActive ? colors.activeBorder : colors.border, 'important');
    el.style.setProperty('color', isActive ? colors.activeText : colors.text, 'important');
    el.style.setProperty('opacity', isDisabled ? '0.45' : '1', 'important');
    el.style.setProperty('pointer-events', isDisabled ? 'none' : 'auto', 'important');
  }

  function applyAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll('.rd-size-link');
    if (!links.length) return;
    var colors = getReferenceColors();
    links.forEach(function (el) {
      applyState(el, colors);
    });
  }

  var watchedEls = new WeakSet();
  function watch(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.rd-size-link').forEach(function (el) {
      if (watchedEls.has(el)) return;
      watchedEls.add(el);
      var observer = new MutationObserver(function () {
        applyState(el, getReferenceColors());
      });
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function init(root) {
    applyAll(root);
    watch(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
